import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import { Props_SnippetUniversityProfile } from './UniversityProfile.props'

const UniversityProfile = (props: Props_SnippetUniversityProfile) => {
    const {
        logo,
        content,
        localisation,
        universityDean,
        repeatable_numberStats: items = [],
        rightImage,
    } = props

    const contentValue = content?.text?.value;
    const localisationIcon = localisation?.icon?.value;
    const universityDeanIcon = universityDean?.icon?.value;
    const localisationVisibility = localisation?.visibility?.value;
    const universityDeanVisibility = universityDean?.visibility?.value;
    const localisationCaptionTop = localisation?.captionTop?.value;
    const localisationCaptionBottom = localisation?.captionBottom?.value;
    const universityDeanCaptionTop = universityDean?.captionTop?.value;
    const universityDeanCaptionBottom = universityDean?.captionBottom?.value;
    const universityDeanTitle = universityDean?.title?.value;
    const rightImageSrc = rightImage?.src?.value;

    return (
        <section className="snippet-university-profile">
            <div className="snippet-university-profile__container">
                <div className="snippet-university-profile__left">
                    {/* University logo and content */}
                    <div className="snippet-university-profile__content">
                        <div className="snippet-university-profile__logo">
                            <img
                                src={logo.src.value}
                                alt=""
                                loading="lazy"
                            />
                        </div>

                        <div className="snippet-university-profile__text">
                            {contentValue && CompileMarkdown(contentValue)}
                        </div>
                    </div>
                    <div className="snippet-university-profile__features">
                        {/* University localisation and dean */}
                        <div className="snippet-university-profile__icon-features">
                            {localisationVisibility && localisationIcon && (
                                <div className="snippet-university-profile__icon-feature">
                                    <img
                                        className="snippet-university-profile__feature-icon"
                                        src={localisation.icon.value}
                                        alt=""
                                        loading="lazy"
                                        width="32"
                                        height="32"
                                    />
                                    <div className="snippet-university-profile__feature-content">
                                        {localisationCaptionTop && (
                                            <p className="snippet-university-profile__feature-label snippet-university-profile__feature-label--small">
                                                {localisationCaptionTop}
                                            </p>
                                        )}
                                        {localisationCaptionBottom && (
                                            <p className="snippet-university-profile__feature-label snippet-university-profile__feature-label--bold">
                                                {localisationCaptionBottom}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}
                            {universityDeanVisibility && universityDeanIcon && (
                                <div className="snippet-university-profile__icon-feature">
                                    <img
                                        className="snippet-university-profile__feature-icon"
                                        src={universityDean.icon.value}
                                        alt=""
                                        loading="lazy"
                                        width="32"
                                        height="32"
                                    />
                                    <div className="snippet-university-profile__feature-content">
                                        {universityDeanCaptionTop && (
                                            <p className="snippet-university-profile__feature-label snippet-university-profile__feature-label--small">
                                                {universityDeanCaptionTop}
                                            </p>
                                        )}
                                        {universityDeanCaptionBottom && (
                                            <p className="snippet-university-profile__feature-label snippet-university-profile__feature-label--bold">
                                                {universityDeanCaptionBottom}
                                            </p>
                                        )}
                                        {universityDeanTitle && (
                                            <p className="snippet-university-profile__feature-label snippet-university-profile__feature-label--title">
                                                {universityDeanTitle}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                        {/* University number stats */}
                        <ul className="snippet-university-profile__number-stats">
                            {items.map((item, index) => (     
                                <li key={"number-stat-" + index} className="snippet-university-profile__number-stat">
                                    <p className="snippet-university-profile__stat-number">
                                        {item.number.value}
                                    </p>
                                    <p className="snippet-university-profile__stat-text">
                                        {item.text.value}
                                    </p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                {/* University right image */}
                <div className="snippet-university-profile__right">
                    <img
                        src={rightImageSrc}
                        alt=""
                        loading="lazy"
                        className="snippet-university-profile__right-image"
                    />
                </div>
            </div>
        </section>
    )
}

export default UniversityProfile;